import styles from "./styles/ContactSupport.module.scss";
import ClickableLink from "../utilities/ClickableLink";
import classNames from "classnames";
import { ReactElement } from "react";

export function ContactSupport(props: {
  className?: string;
  message?: string | ReactElement;
}) {
  const containerClassName = classNames({
    [styles.container]: true,
    [props.className || ""]: props.className,
  });

  return (
    <div className={containerClassName}>
      <p>
        {props.message}
        <span>
          &nbsp;Please reach out to&nbsp;
          <ClickableLink href={"mailto:support@schoolblocks.com"}>
            support@schoolblocks.com
          </ClickableLink>
          &nbsp;for more information.
        </span>
      </p>
    </div>
  );
}
